import $ from 'jquery';

$(document).ready(function () {
  $('#input_1_7').select2();
  $('#input_2_7').select2();
  $('.request-apartment-info-number label').addClass('focused');
  $('.ginput_container input').on('focus', function() {
    $(this).parent().parent().find('label').addClass('focused');
  });
  $('.ginput_container input').on('blur, change', function() {
    if ($(this).val() == '') {
      $(this).parent().parent().find('label').removeClass('focused');
    } else {
      $(this).parent().parent().find('label').addClass('focused');
    }
  });
  $('.ginput_container .select2').on('click', function() {
    $(this).parent().parent().find('label').addClass('focused');
  });
  $('.ginput_container select').on('change', function() {
    if ($(this).find(':selected').text == '') {
      $(this).parent().parent().find('label').removeClass('focused');
    } else {
      $(this).parent().parent().find('label').addClass('focused');
    }
  });
  $('.ginput_container textarea').on('focus', function() {
    $(this).parent().parent().find('label').addClass('focused');
  });
  $('.ginput_container textarea').on('blur, change', function() {
    if ($(this).val() == '') {
      $(this).parent().parent().find('label').removeClass('focused');
    } else {
      $(this).parent().parent().find('label').addClass('focused');
    }
  });
});